import { takeLatest } from "redux-saga/effects";
import { getProductListSaga } from "./saga";
import { GET_PRODUCT_LIST_REQUEST } from "../consts";

// -----------------------------------PRODUCT----------------------------------------------

export function* watchProductList() {
  yield takeLatest(GET_PRODUCT_LIST_REQUEST, getProductListSaga);
}
